/**
 * Top-nav groupings — single source of truth for the dropdowns rendered
 * by `Navbar.jsx`. Add/remove items here; no other file needs to change.
 *
 * Top-level (flagship) items remain inline + reorderable via `useNavOrder`;
 * everything else lives inside one of these grouped dropdowns.
 */
import {
  BookOpen, Sparkles, Video, Mic2, PlaySquare, Brain,
  Wrench, FileImage, Search, Library, Spline,
} from "lucide-react";

// The 5 always-inline top-level items (matches `useNavOrder` defaults).
export const TOP_LEVEL_NAV_IDS = [
  "india",
  "riskpulse",
  "moneyflow",
  "automations",
  "pro",
];

// Grouped dropdowns rendered between the top-level items and the Help icon.
// Each group: { id, label, testId, items[] }.
export const NAV_GROUPS = [
  {
    id: "learn",
    label: "Learn",
    testId: "learn",
    items: [
      { to: "/library",     label: "Library",     hint: "Risk frameworks · primers · long reads",   testId: "nav-group-library",     icon: <Library className="h-3.5 w-3.5" /> },
      { to: "/glossary",    label: "Glossary",    hint: "Plain-English definitions of every term",   testId: "nav-group-glossary",    icon: <Spline className="h-3.5 w-3.5" /> },
      { to: "/newsletters", label: "Newsletters", hint: "Subscribe to weekly briefs",                testId: "nav-group-newsletters", icon: <Sparkles className="h-3.5 w-3.5" /> },
      { to: "/guide",       label: "Guide",       hint: "Step-by-step onboarding for new members",   testId: "nav-group-guide",       icon: <BookOpen className="h-3.5 w-3.5" /> },
    ],
  },
  {
    id: "watch",
    label: "Watch",
    testId: "watch",
    items: [
      { to: "/webinars", label: "Webinars",   hint: "Live + on-demand sessions",                  testId: "nav-group-webinars", icon: <Video className="h-3.5 w-3.5" /> },
      { to: "/speakers", label: "Speakers",   hint: "Hire experts for events + boardrooms",       testId: "nav-group-speakers", icon: <Mic2 className="h-3.5 w-3.5" /> },
      { to: "/youtube",  label: "Shorts",     hint: "Quick video clips from RiskPedia YouTube",   testId: "nav-group-youtube",  icon: <PlaySquare className="h-3.5 w-3.5" /> },
      { to: "/eval",     label: "AI Eval",    hint: "Benchmark AI models on Indian risk + GRC",   testId: "nav-group-eval",     icon: <Brain className="h-3.5 w-3.5" /> },
    ],
  },
  {
    id: "tools",
    label: "Tools",
    testId: "tools",
    items: [
      { to: "/tools",         label: "All tools",     hint: "Browse the full toolbox",                testId: "nav-group-tools",         icon: <Wrench className="h-3.5 w-3.5" /> },
      { to: "/carousel-lite", label: "Carousel Lite", hint: "Build LinkedIn carousels in minutes",    testId: "nav-group-carousel",      icon: <FileImage className="h-3.5 w-3.5" /> },
      { to: "/finder",        label: "Finder",        hint: "Find people · talks · jobs in risk",     testId: "nav-group-finder",        icon: <Search className="h-3.5 w-3.5" /> },
    ],
  },
];
